<vy-layout-page-hero [imageHero]="getImageLayout(state().imageLayout!)" [overlayBlur]="overLayBlur">
  <ng-container header>
    <app-banner-alert [alerts]="state().globalAlerts"></app-banner-alert>
    <app-header [language]="state().language" [userInfo]="state().user" [isTransparent]="false"></app-header>
  </ng-container>

  <ng-container hero>
    <app-searcher-wrapper
      [culture]="state().language!"
      [currency]="state().currency!"
      (blurEvent)="updateBlurEvent($event)"
    ></app-searcher-wrapper>
  </ng-container>

  <ng-container main>
    <app-generic-options [lowerImportedCard]="lowerCards()" [upperImportedCards]="upperCards()"></app-generic-options>
  </ng-container>

  <ng-container footer>
    <app-footer
      [language]="state().language ?? 'es'"
      [userType]="state().user?.userType?.toLocaleLowerCase() ?? 'default'"
    ></app-footer>
  </ng-container>
</vy-layout-page-hero>
